import React, {useEffect, useState} from 'react'
import {KTIcon} from '../../../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import {ModeleClient, modeleClientDemandeInitValues} from '../../../../../components/Models'
import {getClients, getDemandeSource} from '../../../../../components/requests'
import {LoadingData} from '../../../../../components/LoadingData'
import {useFormik} from 'formik'
import {Pagination} from '../../../../../components/Pagination'
import {useAuth} from '../../../../modules/auth'
import {shouldDisplayFonctionnalite} from '../../../../../components/helpers'
import ResearchVehicleModal from '../../../demande/Components/ResearchVehicleModal'
import {Tooltip} from 'react-tooltip'
import ChoixContactModal from '../../../demande/Components/ChoixContactModal'

const ClientsListPage = () => {
  const [data, setData] = useState<Array<ModeleClient>>([])
  const [loading, setLoading] = useState(false)
  const [nombreDePages, setNombreDePages] = useState<number>(0)
  const [totalPages, setTotalPages] = useState<number>(0)
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [searchPage, setSearchPage] = useState<string>('')
  const [isSearch, setIsSearch] = useState(false)
  const [selectedId, setSelectedId] = useState<number>()
  const {currentUser} = useAuth()
  const [redirectToClientDemande] = useState<boolean>(true)
  const [searchStatut, setSearchStatut] = useState<any>('')
  const [searchType, setSearchType] = useState<any>('')
  const [defaultValueContact, setDefaultValueContact] = useState<any>('')
  const [isFromAddClientContact, setIsFromAddClientContact] = useState<boolean>(false)
  const [radioValue, setRadioValue] = useState<string>('')
  const [isClientSociety, setIsClientSociety] = useState<boolean>(false)
  const [sourceLoader, setSourceLoader] = useState<boolean>(false)
  const [choicedDemandeSource, setChoicedDemandeSource] = useState<{value: number; label: string}>()
  const [demandeSources, setDemandeSource] = useState<any | undefined>([])
  const [contentCommunication, setContentCommunication] = useState<any>('')
  const [isDuplicate, setIsDuplicate] = useState<boolean>(false)
  const [contactedBy, setContactedBy] = useState<any | null>(null)

  useEffect(() => {
    getClientsData()
  }, [currentPage, searchPage, searchStatut, searchType])

  const getClientsData = () => {
    setLoading(true)
    getClients(!isSearch ? currentPage : 1, searchPage, searchStatut, searchType).then(
      (clientsRequest) => {
        setNombreDePages(clientsRequest?.pages)
        setTotalPages(clientsRequest?.total)
        setCurrentPage(clientsRequest?.page)
        if (clientsRequest?.data !== undefined) {
          setData(clientsRequest?.data)
          setLoading(false)
          setIsSearch(false)
        }
      }
    )
  }

  const formik = useFormik({
    initialValues: {allSearch: '', statut: '', type: ''},
    onSubmit: (values, {setSubmitting}) => {
      setSearchPage(values.allSearch)
      setSearchStatut(values.statut)
      setSearchType(values.type)
    },
  })

  const OnchangeOptions = (value, critere) => {
    formik.setFieldValue(critere, value)
    setIsSearch(true)
    formik.submitForm()
  }

  // Récupération liste des sources de demande
  const getClientDemandeSourceData = () => {
    setSourceLoader(true)
    return getDemandeSource().then((demandeSourceRequest) => {
      if (demandeSourceRequest?.status === 200) {
        if (demandeSourceRequest?.data !== undefined) {
          setSourceLoader(false)
          setDemandeSource(demandeSourceRequest?.data)
        }
      }
    })
  }

  useEffect(() => {
    getClientDemandeSourceData()
  }, [])

  // Transformation source demande en objet value label pour ne pas gâcher le donnée originel
  const transformedSource = demandeSources?.map((item) => ({
    value: item.id,
    label: item.name,
  }))

  return (
    <>
      {/* begin::Row  */}
      {shouldDisplayFonctionnalite(currentUser, 'VOIR CLIENT') && (
        <div className='row g-5 g-xl-8'>
          {/* begin::Col  */}
          <div className='col-xxl-12'>
            <div className={`card card-xxl-stretch mb-5 mb-xl-8`}>
              {/* begin::Header */}
              <div className='card-header border-0 pt-5 justify-content-end'>
                {shouldDisplayFonctionnalite(currentUser, 'AJOUTER CLIENT') && (
                  <div
                    className='card-toolbar'
                    data-bs-toggle='tooltip'
                    data-bs-placement='top'
                    data-bs-trigger='hover'
                    title='Click to add a user'
                  >
                    <Link to={`/vente/clients/ajouter`} className='btn btn-sm btn-light-primary'>
                      <KTIcon iconName='plus' className='fs-3' />
                      Créer un client
                    </Link>
                  </div>
                )}
              </div>
              {/* debut champs recherche */}
              <form className='card-header border-0 pt-5 pb-5' onSubmit={formik.handleSubmit}>
                {/* debut recherche par statut*/}
                <div className='col-lg-3'>
                  <select
                    name='statut'
                    id='statut'
                    className='form-select form-select-solid form-select-lg fw-bold'
                    onChange={(e) => OnchangeOptions(e.target.value, 'statut')}
                  >
                    <option value=''>Statut</option>
                    <option key='0' value='CLIENT'>
                      Client
                    </option>
                    <option key='1' value='PROSPECT'>
                      Prospect
                    </option>
                  </select>
                </div>
                {/* fin recherche par statut*/}

                {/* debut recherche par type*/}
                <div className='col-lg-3'>
                  <select
                    name='type'
                    id='type'
                    className='form-select form-select-solid form-select-lg fw-bold'
                    onChange={(e) => OnchangeOptions(e.target.value, 'type')}
                  >
                    <option value=''>Type</option>
                    <option key='0' value='0'>
                      Particulier
                    </option>
                    <option key='1' value='1'>
                      Professionnel
                    </option>
                  </select>
                </div>
                {/* fin recherche par type*/}

                <div className='form-group d-flex col-lg-4'>
                  <div className='input-group'>
                    <input
                      type='text'
                      className='form-control h-100'
                      {...formik.getFieldProps('allSearch')}
                      name='allSearch'
                      placeholder='Rechercher un client'
                    />
                    <button
                      type='submit'
                      className='btn btn-light border-0 input-group-append h-100'
                      onClick={() => setIsSearch(true)}
                    >
                      <i className='fas fa-search text-secondary fs-1'></i>
                    </button>
                  </div>
                </div>
              </form>
              {/* fin champs recherche */}

              {/* end::Header */}
              {loading ? (
                <LoadingData />
              ) : (
                <>
                  {shouldDisplayFonctionnalite(currentUser, 'VOIR CLIENT') && (
                    <div className='card-body py-3'>
                      {/* begin::Table container */}
                      <div className='table-responsive'>
                        {/* begin::Table */}
                        <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                          {/* begin::Table head */}
                          <thead>
                            <tr className='fw-bold text-muted'>
                              <th className='min-w-140px'>Code Koena</th>
                              <th className='min-w-150px'>Client</th>
                              <th className='min-w-140px'>Code Atemo Auto</th>
                              <th className='min-w-140px'>Code Atemo Moto</th>
                              <th className='min-w-140px'>Code Atemo Industrie</th>
                              <th className='min-w-140px'>Société</th>
                              <th className='min-w-140px'>Localisation</th>
                              <th className='min-w-140px'>Type</th>
                              <th className='min-w-100px text-end'>Actions</th>
                            </tr>
                          </thead>
                          {/* end::Table head */}
                          {/* begin::Table body */}
                          <tbody>
                            {data.length ? (
                              data.map((client) => {
                                return (
                                  <>
                                    <tr key={client[0].id}>
                                      <td>
                                        <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                          {client[0].id}
                                        </p>
                                      </td>
                                      <td>
                                        <div className='d-flex align-items-center'>
                                          <div className='d-flex justify-content-start flex-column'>
                                            {shouldDisplayFonctionnalite(
                                              currentUser,
                                              'VOIR FICHE'
                                            ) ? (
                                              <Link
                                                to={`/vente/clients/${client[0].id}/afficher`}
                                                className='text-dark fw-bold text-hover-primary fs-6 mb-0'
                                              >
                                                {client[0].nom} {client[0].prenom}
                                              </Link>
                                            ) : (
                                              <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                                {client[0].nom} {client[0].prenom}
                                              </p>
                                            )}
                                            <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                              Groupe {client['group']}
                                            </span>
                                          </div>
                                        </div>
                                      </td>
                                      <td>
                                        <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                          {client[0].codeClientAAuto}
                                        </p>
                                      </td>
                                      <td>
                                        <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                          {client[0].codeClientAMoto}
                                        </p>
                                      </td>
                                      <td>
                                        <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                          {client[0].codeClientAIndus}
                                        </p>
                                      </td>
                                      <td>
                                        <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                          {client[0].nomSociete}
                                        </p>
                                        <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                          Type société (Garage, carosserie...)
                                        </span>
                                      </td>
                                      <td>
                                        <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                          {client[0].ville}
                                        </p>
                                        <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                          {client[0].codePostal} {client[0].pays?.nom}
                                        </span>
                                      </td>
                                      <td>
                                        {client[0]?.typeClient && (
                                          <>
                                            <span
                                              className={
                                                client[0].typeClient == 'PROSPECT'
                                                  ? `fw-bolder px-4 badge mb-1 badge-prosp`
                                                  : `fw-bolder px-9 badge mb-1 badge-light-primary`
                                              }
                                            >
                                              {client[0].typeClient}
                                            </span>
                                            <br />
                                          </>
                                        )}
                                        {client[0].professionnel ? (
                                          <span className='badge badge-prof fw-bolder me-auto px-4'>
                                            Professionnel
                                          </span>
                                        ) : (
                                          <span className='badge badge-part fw-bolder me-auto px-4'>
                                            Particulier
                                          </span>
                                        )}
                                      </td>
                                      <td>
                                        <div className='d-flex justify-content-end flex-shrink-0'>
                                          {shouldDisplayFonctionnalite(
                                            currentUser,
                                            'AJOUTER CLIENT DEMANDE'
                                          ) && (
                                            <>
                                              <div
                                                className='btn btn-icon btn-light-primary btn-bg-light btn-active-color-white btn-sm me-1'
                                                data-bs-target='#choixContactModal'
                                                data-bs-toggle='modal'
                                                data-bs-dismiss='modal'
                                                data-tooltip-id='tooltip'
                                                data-tooltip-content='Choisir un contact'
                                                data-tooltip-place='left'
                                                onClick={() => {
                                                  setSelectedId(client[0].id)
                                                  setIsClientSociety(true)
                                                }}
                                              >
                                                <i className='bi-file-earmark-plus fs-2'></i>
                                              </div>
                                            </>
                                          )}
                                          {shouldDisplayFonctionnalite(
                                            currentUser,
                                            'VOIR FICHE'
                                          ) && (
                                            <Link
                                              to={`/vente/clients/${client[0].id}/afficher`}
                                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                              data-tooltip-id='tooltip'
                                              data-tooltip-content='Détail du client'
                                              data-tooltip-place='right'
                                            >
                                              <i className='bi bi-person-vcard fs-2'></i>
                                            </Link>
                                          )}
                                        </div>
                                      </td>
                                    </tr>
                                  </>
                                )
                              })
                            ) : (
                              <tr>
                                <td colSpan={5} className='text-center'>
                                  Aucun résultat trouvé
                                </td>
                              </tr>
                            )}
                          </tbody>
                          {/* end::Table body */}
                        </table>
                        {/* end::Table */}
                      </div>
                      {/* end::Table container */}

                      {/*Modal recherche de véhicule*/}
                      <ResearchVehicleModal
                        clientId={selectedId}
                        isFromClient={true}
                        data={modeleClientDemandeInitValues}
                        redirectToClientDemande={redirectToClientDemande}
                        defaultValueContact={defaultValueContact}
                        setSourceLoader={setSourceLoader}
                        sourceLoader={sourceLoader}
                        transformedSource={transformedSource}
                        choicedDemandeSource={choicedDemandeSource}
                        setChoicedDemandeSource={setChoicedDemandeSource}
                        contactedBy={contactedBy}
                      />
                      {/*Modal choix de contact client*/}
                      <ChoixContactModal
                        clientId={selectedId}
                        setDefaultValueContact={setDefaultValueContact}
                        defaultValueContact={defaultValueContact}
                        isFromAddClientContact={isFromAddClientContact}
                        setIsFromAddClientContact={setIsFromAddClientContact}
                        setRadioValue={setRadioValue}
                        isClientSociety={isClientSociety}
                        isFromClientList={true}
                        contentCommunication={contentCommunication}
                        setContentCommunication={setContentCommunication}
                        isDuplicate={isDuplicate}
                        setIsDuplicate={setIsDuplicate}
                        setContactedBy={setContactedBy}
                        radioValue={radioValue}
                      />

                      {/* begin::pagination*/}
                      <Pagination
                        totalPages={totalPages}
                        nombreDePages={nombreDePages}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        locationState={0}
                      />
                      {/* end::pagination*/}
                      {/*Affichage du tooltip*/}
                      <Tooltip id='tooltip' />
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
          {/* end::Col  */}
        </div>
      )}
      {/* end::Row  */}
    </>
  )
}

export {ClientsListPage}
